export default __webpack_public_path__ + "static/media/MINUTA_CONTRATUAL_BR.dade1e71.pdf";